function removeDashesAndUnderscores(s: string) {
    return s.replace(/-/g, '').replace(/_/g, '');
}

export const toModuleName = (s: string) =>
    removeDashesAndUnderscores(s || '').toLowerCase();

export const getModuleNameFromPath = (path: string | undefined) => {
    if (!path) return undefined;
    const regexResult =
        /^.+\/modules(.+)?\/(?<moduleName>[^/]+)\/module\.ts$/.exec(path);

    if (!regexResult) return undefined;

    let { moduleName } = regexResult.groups ?? {};
    if (moduleName.includes('-'))
        moduleName = removeDashesAndUnderscores(moduleName);

    return toModuleName(moduleName);
};
